import './vendors';
import '../css/styles.scss';
import ParallaxBlock from './parallax';
import FormularioContacto from './formulario_contacto';

$(document).ready(function() {
    /**
     * Fixes de swiper.
     */
    (function() {
        const swiper_testimonios = new Swiper('.testimonio .swiper-container', {
            pagination: '.swiper-pagination',
            paginationClickable: true,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            spaceBetween: 30,
        });

        const swiper_clientes = new Swiper('.content-clients .swiper-container', {
            pagination: '.swiper-pagination',
            paginationClickable: true,
            spaceBetween: 30,
            slidesPerView: 4,
        });
        $(window).resize(function() {
            const ww = $(window).width();
            if (ww > 468) swiper_clientes.params.slidesPerView = 4;
            if (ww < 768) swiper_clientes.params.slidesPerView = 2;
            if (ww <= 468) swiper_clientes.params.slidesPerView = 1;
            swiper_clientes.update()
        });

        $(window).trigger('resize');
    })();

    /**
     * Fixes para header.
     */
    (function() {

        const header = $("header");
        const affixable = $('#affixable');

        $('body').scrollspy({ target: '#affixable' });

        class eventHandler {
            constructor(__object, __event) {
                this._object = __object;
                this._event = __event;
            }
        }

        new ParallaxBlock('header');

        header.height(window.innerHeight);
        [new eventHandler(document, 'scroll'), new eventHandler(window, 'resize')]
        .map((event_handler) => {
            event_handler._object.addEventListener(event_handler._event, () => {
                header.height(window.innerHeight);

            });
        });

        affixable.affix({
            offset: {
                top: header.height() - affixable.height() - 1
            }
        });

        $(".navbar a").on('click', function(event) {
            if (this.hash !== "") {
                event.preventDefault();
                let hash = this.hash;
                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 800, function() {
                    window.location.hash = hash;
                });
            }
        });

        $(document).click(function(event) {
            const target = $(event.target);
            const navbar = $(".navbar-collapse");
            const _opened = navbar.hasClass("in");
            if (_opened === true && !target.hasClass("navbar-toggle")) {
                navbar.collapse('hide');
            }
        });
    })();

    /**
     * Wework
     */
    (function() {
        new ParallaxBlock('#wework div.img');
    })();

    /**
     * Clientes
     */
    (function() {
        new ParallaxBlock('#cliente');
    })();

    /**
     * Formulario
     */
    (function() {
        const formulario = new FormularioContacto('#formulario-contacto');
    })();
});

if ("production" !== process.env.NODE_ENV) {
    require('../../index.html');
}


// WEBPACK FOOTER //
// ./js/app.js